export {
    Type,
    JSON,
    fromJSON,
    instanceOf,
    create,
    toCBOR,
    fromCBOR,
    fromString,
    registerCBOREncoder,
} from '../../plt/TokenMetadataUrl.js';
